import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import "./Home.css";
import Slider from "../../components/Slider/Slider";
import HomeBanner from "./../../assets/homepagebannernew2.webp";
import HomeBannerMobil from "./../../assets/homepagebannermobile.webp";
import HomeProduct from "../../components/HomeProduct/HomeProduct";
import Application from "../../components/Application/Application";
// import HomeServices from "../../components/HomeServices/HomeServices";
import categoryData from "../../api/categories";
import { formatPage } from "../../utils/formatPage";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import required modules
import { Pagination } from "swiper/modules";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
// import GoogleLogin from "../../components/GoogleLogin/GoogleLogin";

const Home = () => {
  const { t } = useTranslation();

  // const [form] = useState({
  //   nameSurname: "",
  //   phone: "",
  //   address1: "",
  //   address2: "",
  //   country: "",
  //   city: "",
  //   state: "",
  //   postalCode: "",
  // });

  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("home.meta.title"),
      description: t("home.meta.description"),
      keywords: t("home.meta.keywords"),
      siteName: "Touch Of Soul",
      favicon: "/faviconnew.png",
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com",
      ogType: "website", // ya da 'website'
    });
  }, [setSeo, t]);

  return (
    <>
      <Slider />
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h3 className="text-center fw-normal py-5 pb-3">
              {t("Shop by Category")}
            </h3>
          </div>
        </div>
        <div className="row">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 3,
              },
              1440: {
                slidesPerView: 4,
              },
            }}
          >
            {categoryData.category.map((category) => (
              <SwiperSlide key={category.id}>
                <a
                  href={`/category/${formatPage(category.categoryname)}`}
                  className="text-decoration-none"
                >
                  <img
                    src={category.categoryimage}
                    className="w-100"
                    alt={t(`${category.categoryname}`)} // Dynamic alt text
                  />
                  <p className="text-center fw-light mt-3 mb-5 text-dark fs-6 text-uppercase">
                    {t(category.translationKey) || category.categoryname}
                  </p>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div className="container-fluid mt-5">
        <div className="row position-relative text-center">
          {/* Masaüstü Görseli */}
          <div className="col-lg-12 pe-0 px-0 d-none d-sm-block position-relative">
            <a href="/perfume">
              <img
                src={HomeBanner}
                className="w-100"
                alt={t("PerfumeImageAlt")}
              />
              <div className="position-absolute top-50 start-50 translate-middle">
                <p className="text-white fw-lighter fs-3">
                  {t("Discover more")}
                </p>
              </div>
            </a>
          </div>

          {/* Mobil Görseli */}
          <div className="col-lg-12 pe-0 px-0 d-block d-sm-none position-relative">
            <a href="/perfume">
              <img
                src={HomeBannerMobil}
                className="w-100"
                alt={t("PerfumeImageAlt")}
              />

              <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                <p className="text-white fw-light text-decoration-underline">
                  {t("Discover more")}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            {t("Shop")}
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("Visit our Store")}
          </h3>
          <HomeProduct />
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MUKEMEL
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("CustomerReviews")}
          </h3>
          <div className="col-lg-8">
            <CustomerReviews />
          </div>
        </div>
      </div>

      {/* <div className="container mt-5 mb-5">
        <div className="row">
          <h3 className="text-center pt-0  fw-light">
            {t("Mukemel Services")}
          </h3>
          <p className="fw-lighter text-center pb-4">
            {t("Mukemel Services Desc")}
          </p>
          <HomeServices />
        </div>
      </div> */}
      <Application />
      <div className="container">
        {/* <GoogleLogin
          checkoutAddress={{
            name: form.nameSurname,
            phone: form.phone,
            address1: form.address1,
            address2: form.address2,
            country: form.country,
            city: form.city,
            state: form.state,
            postalCode: form.postalCode,
          }}
        /> */}
      </div>
    </>
  );
};
export default Home;
